<template>
	<div v-if="isErrorForm && canConsent" class="errors">
		<span class="perr">{{errorForm}}</span>
	</div>
	<div class="grid consent-form" v-if="canConsent">
		<div class="gd" id="consent-form-select">
			<div>
				<sym-icon name="consent"/> {{env.msg('form.addConsent')}}: 
				<select v-model.number="consent" tabindex='150'>
				  <option value="0">-</option>
				  <option v-for="item in consentList" :value="item.value">
					{{ item.name }}
				  </option>
				</select>
				<span v-if="isErrorProperty" class="perr">{{errorProperty}}</span>
			</div>
		</div>
		<div class="gd" id="consent-form-buttons">
			<button class="fbutton" style="--button-hue:0" @click="disagreeConsent" :disabled='disabledButton' tabindex='250'>{{env.msg('butt.disagree')}}</button>
			<button class="fbutton" style="--button-hue:120" @click="agreeConsent" :disabled='disabledButton' tabindex='200'>{{env.msg('butt.agree')}}</button>&nbsp;
		</div>
		<Transition name="consent-description" >
			<div class="gd" id="consent-form-desc" v-if="isSelectedConsent">
				<textarea v-model="description" cols='48' rows="2" tabindex='150' class="width100p"></textarea>
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed, onMounted } from 'vue';
	import {msg} from "../../i18n/Message";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import {injectEnv} from "@fd/Environment";
	
	const props = defineProps({
		party: { type: Number, default: 0 },
		canConsent: Boolean,
		sourceType: Number
	});
	
	const env = injectEnv();
	
	const consent = ref(0);
	const description = ref("");
	const errorForm = ref("");
	const errorProperty = ref("");
	const consentList = ref([]);
	
	const emit = defineEmits(['refresh']);

	const disabledButton = computed(() => {
		return consentList.value.length===0;
	});
	
	const isErrorForm = computed(() => {
		return  !!errorForm.value;// !== null && errorForm.value !== undefined && errorForm.value.length>0;
	});
	
	const isErrorProperty = computed(() => {
		return  !!errorProperty.value;// !== null && errorProperty.value !== undefined && errorProperty.value.length>0;
	});
	
	const isSelectedConsent = computed(() => {
		return consent.value !== 0;
	});
	
	
	function agreeConsent(): void {
		addConsent(true);
	}
		
	function disagreeConsent(): void {
		addConsent(false);
	}
	
	function addConsent(value: boolean): void {
		errorForm.value = "";
		if (consent.value === 0) {
			errorProperty.value = env.msg('err.empty');
		}
		else {
			errorProperty.value = "";
			var data = {
			  "type": consent.value,
			  "source": props.sourceType,
			  "description": description.value,
			  "party": props.party,
			  "value": value
			}
			fetch("./api/consents", {
			  method: 'POST',
			  headers: { 'Content-Type': 'application/json; charset=utf-8' },
			  body: JSON.stringify(data)
			})
			.then(response => {
				if (response.ok) {
					//remove added campaign from list
					consent.value = 0;
					description.value = "";
					//refresh table
					emit('refresh');
				}
				else {
					console.error('Error:', response.status);
					errorForm.value = "RestApi point return status:"+response.status;
				}
			})
			.catch((error) => {
			  console.error('Error:', error);
			  errorForm.value = "Error to fetch restApi point";
			});
		}
	}
	
	function loadData(): void {
		consentList.value = [];
		return fetch("./api/lists/_cct?onlyEnabled=true")
		.then(response => response.json())
		.then(data => {
			if (data) {
				consentList.value = data.items;
			}
			else {
				console.log("Loaded consent's list is invalid");
				errorForm.value = "Loaded consent's list is invalid";
			}
		})
		.catch((error) => {
			console.log("Error loading consent's list:"+error);
			errorForm.value = error;
		});
	}
	
	onMounted(() => {
		loadData();
	});
</script>

<style>
.consent-form {
	grid-template-areas: "cf-select cf-buttons"
			"cf-desc cf-desc";
	border-radius: var(--panel-radius);
	padding: var(--view-header-v-padding);
	overflow:hidden;
	align-items: baseline;
	column-gap: 8px;
}
.o-small .consent-form {
	grid-template-areas: "cf-select"
			"cf-desc"
			"cf-buttons";
}
#consent-form-select { grid-area: cf-select; }
#consent-form-buttons {
	grid-area: cf-buttons;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	align-items: center;
	column-gap:8px;
}
#consent-form-desc { grid-area: cf-desc; padding-top: 8px; }
</style>